import { useEffect } from "react"
import { useLocation } from "react-router-dom"

export default function useLocationChange( fn ) {

	const location = useLocation();

	useEffect(() => { fn && fn()}, [ location.pathname ])
}